import { actions } from '../../../../utils/constants';

export const fetchCoachData = () => ({
    type: actions.ASYNC_FETCH_COACH_DATA,
});



// WEBPACK FOOTER //
// ./src/components/internal-pages/components/coach-pages/coach-pages.actions.js